export const firebaseConfig = {
    apiKey: "AIzaSyB_XqA5VIuzRqq9CLseBgbDf65HPODXACM",
    authDomain: "aquakoek.firebaseapp.com",
    databaseURL: "https://aquakoek.firebaseio.com",
    projectId: "aquakoek",
    storageBucket: "",
    messagingSenderId: "361832055954"
};
